
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 364 281","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M234.099 118.966a18.692 18.692 0 0018.738 18.738 18.692 18.692 0 0018.738-18.738 18.692 18.692 0 00-18.738-18.738 18.695 18.695 0 00-18.738 18.738zm-52.148-18.734a18.692 18.692 0 0118.738 18.738 18.692 18.692 0 01-18.738 18.738 18.692 18.692 0 01-18.738-18.738 18.692 18.692 0 0118.738-18.738zm-70.887 0a18.692 18.692 0 0118.738 18.738 18.692 18.692 0 01-18.738 18.738 18.692 18.692 0 01-18.738-18.738 18.694 18.694 0 0118.738-18.738zm-63.207 180.6l64.562-50.344h216.72c19.188 0 34.539-15.578 34.539-34.539V34.539C363.678 15.351 348.1 0 329.139 0h-294.6C15.351 0 0 15.578 0 34.539v161.18c0 19.188 15.578 34.539 34.539 34.539h13.094l.224 50.574zm285.28-270.77c9.031 0 20.48 11.449 20.48 20.48v169.18c0 9.031-11.449 20.48-20.48 20.48h-230.65l-44.344 35.543v-35.543H30.764c-9.031 0-20.48-11.449-20.48-20.48V30.542c0-9.031 11.449-20.48 20.48-20.48h302.373z","fill-rule":"nonzero","fill":"currentColor"}})])
          )
        }
      }
    